// extracted by mini-css-extract-plugin
export default {"wrap":"ClientsComponent_wrap__B3IQc","menuBlock":"ClientsComponent_menuBlock__8ZWJ2","listBlock":"ClientsComponent_listBlock__Y3ann"};